import { atom } from "recoil";

const authAtom = atom<boolean>({
    key: 'authState',
    default: false
  });
  
  export { authAtom };